import * as THREE from 'three';

export interface VisualAssetMeshBundle {
  group: THREE.Group;
  materials: THREE.MeshStandardMaterial[];
  labelOffset: number;
}

export function createVisualAssetMesh(assetId: string): VisualAssetMeshBundle {
  const materials: THREE.MeshStandardMaterial[] = [];
  const group = new THREE.Group();

  if (assetId === 'tree') {
    const trunk = new THREE.Mesh(
      new THREE.CylinderGeometry(0.08, 0.11, 0.72, 10),
      makeMaterial('#6b3f1d', materials),
    );
    trunk.position.y = 0.36;
    group.add(trunk);

    const crownBottom = new THREE.Mesh(
      new THREE.ConeGeometry(0.4, 0.7, 12),
      makeMaterial('#2f6c3d', materials, { emissive: '#1f5131', emissiveIntensity: 0.18 }),
    );
    crownBottom.position.y = 0.88;
    group.add(crownBottom);

    const crownTop = new THREE.Mesh(
      new THREE.ConeGeometry(0.28, 0.5, 12),
      makeMaterial('#3d8b4e', materials, { emissive: '#256c3b', emissiveIntensity: 0.15 }),
    );
    crownTop.position.y = 1.18;
    group.add(crownTop);

    return { group, materials, labelOffset: 1.5 };
  }

  const crystal = new THREE.Mesh(
    new THREE.OctahedronGeometry(0.28, 0),
    makeMaterial('#c084fc', materials, { emissive: '#7c3aed', emissiveIntensity: 0.25 }),
  );
  crystal.position.y = 0.38;
  group.add(crystal);
  return { group, materials, labelOffset: 0.9 };
}

function makeMaterial(
  color: string,
  materials: THREE.MeshStandardMaterial[],
  overrides?: Partial<THREE.MeshStandardMaterialParameters>,
): THREE.MeshStandardMaterial {
  const material = new THREE.MeshStandardMaterial({
    color,
    roughness: 0.72,
    metalness: 0.08,
    transparent: true,
    ...overrides,
  });
  materials.push(material);
  return material;
}
